export default __webpack_public_path__ + "66a8bffcd93e7acae4e457d6bb95efda.png";